"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetResponseToJSON = exports.AssetResponseFromJSONTyped = exports.AssetResponseFromJSON = void 0;
function AssetResponseFromJSON(json) {
    return AssetResponseFromJSONTyped(json, false);
}
exports.AssetResponseFromJSON = AssetResponseFromJSON;
function AssetResponseFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AssetResponseFromJSONTyped = AssetResponseFromJSONTyped;
function AssetResponseToJSON(value) {
    return value;
}
exports.AssetResponseToJSON = AssetResponseToJSON;
